import { defineComponent as _defineComponent } from 'vue'
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds'
import { type ImpactGoalType, type ImpactType, TemplateEngineContext } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'submit',
  props: {
    impactGoal: null,
    impact: null
  },
  setup(__props: any) {



return { __sfc: true,IMPACT_SECTION_IDS, TemplateEngineContext }
}

})